
import MessageAdd from "../../../assets/outline/MessageAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageAddIcon({ className, dataTestid = "MessageAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MessageAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
